/**
 * Representa a view home do drawer de configurações avançadas.
 */
const HOME = "home";

/**
 * Representa a view de domnínio personalizado do drawer de configurações avançadas.
 */
const CUSTOM_DOMAIN = "CustomDomain";

/**
 * Representa a view de estratificações do drawer de configurações avançadas.
 */
const STRATIFICATION = "Stratification";

export default {
	HOME,
	CUSTOM_DOMAIN,
	STRATIFICATION,
};
